import React, { useEffect, useState } from "react";
import { Accordion, Card, Modal, useAccordionButton } from "react-bootstrap";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import paypalImg from '../../assets/images/paypal.png';
import { CreateSubscriptionService, SaveCardListService } from "../../services/AdminService";
import { PaymentIcon } from 'react-svg-credit-card-payment-icons';
import { LoadingSpinnerDotted } from "../loading-spinner/Loader";
import { SaveCardPlaceholder } from "../skeleton-placeholder";
import StatusModal from "./StatusModal";
import PaypalElement from "./PaypalElement";
import StripeElement from "./StripeElement";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

function CustomToggle({ children, eventKey, activeKey, setActiveKey }) {
    const handlePaymentOption = useAccordionButton(eventKey, () =>
        // console.log('eventKey==>', eventKey),
        setActiveKey((prevKey) => (prevKey === eventKey ? null : eventKey))
    );
    return (
        <Card.Header
            onClick={handlePaymentOption}
            className={`card-block ${activeKey === eventKey ? "active" : ""} ${eventKey === "anotherPay" ? "another-pay-item" : "saved-card-item"}`}
        >
            {children}
        </Card.Header>
    );
}


function PaymentModal({ showPaymentModal, setShowPaymentModal, subscriptionData, subscriptionFnc }) {
    const [showStatusModal, setShowStatusModal] = useState({ isOpen: false, type: null });
    const [isLoadingCard, setIsLoadingCard] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [savedCardList, setSavedCardList] = useState([]);

    const [activeKey, setActiveKey] = useState(null);

    const handlePaymentCancel = () => setShowPaymentModal(false);

    const getSaveCardList = async () => {
        setIsLoadingCard(true);
        await SaveCardListService("", (res) => {
            if (res.status === 200) {
                // console.log("Save card list Data==>", res.data);
                const { paymentMethods } = res.data;
                setSavedCardList(paymentMethods);
                setActiveKey(paymentMethods?.customer?.invoice_settings?.default_payment_method || "anotherPay");
            } else {
                console.log(`Error: ${res.data?.message || "An unexpected error occurred."}`);
            }
            setIsLoadingCard(false);
        });
    }

    const handleSubmitCardPay = async () => {
        const getCardData = savedCardList?.data?.find((item) => item.id === activeKey) || null;
        // console.log("getCardData===>", getCardData, activeKey)
        setIsProcessing(true);
        if (getCardData) {
            await CreateSubscriptionService({
                priceId: subscriptionData.priceId,
                productId: subscriptionData.productId,
                type: "stripe",
            }, (res) => {
                if (res.status === 200) {
                    // console.log("createz xczxc Subscription Data==>", res.data);
                    if (res.data.success) {
                        setShowStatusModal({ isOpen: true, type: "success" });
                        handlePaymentCancel();
                    } else {
                        setShowStatusModal({ isOpen: true, type: "failure" });
                        handlePaymentCancel();
                    }
                } else {
                    console.log(`Error: ${res.data?.message || "An unexpected error occurred."}`);
                }
                setIsProcessing(false);
            });
        }
    }

    useEffect(() => {
        getSaveCardList();
    }, []);

    return (
        <>
            <Modal
                show={showPaymentModal}
                onHide={() => handlePaymentCancel()}
                keyboard={false}
                backdrop="static"
                size="md"
                className="add-travellers-modal"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Payment Method
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {isLoadingCard ?
                        <div className="saved-card-list last-item-margin-0">
                            <SaveCardPlaceholder number={3} />
                        </div>
                        : <>
                            <Accordion defaultActiveKey={activeKey}>
                                <>
                                    {savedCardList?.data?.length > 0 ? (
                                        <div className="saved-card-block">
                                            {/* <h6 className="saved-card-block-title">Paying with Card</h6> */}
                                            <div className="saved-card-list">
                                                {savedCardList?.data?.map((item) => {
                                                    return (
                                                        <CustomToggle key={item.id} eventKey={item.id} activeKey={activeKey} setActiveKey={setActiveKey}>
                                                            <div className="saved-card-type">
                                                                <PaymentIcon type={item.card.brand} format="flatRounded" width={44} />
                                                            </div>
                                                            <div className="saved-card-info">
                                                                <p><span className="text-capitalize">{item.card.brand}</span> ending in {item.card.last4}</p>
                                                                <p className="saved-card-date">Exp. {item.card.exp_month}/{item.card.exp_year}</p>
                                                                {savedCardList?.customer?.invoice_settings?.default_payment_method === item?.id && <span className="saved-card-default">Default</span>}
                                                            </div>
                                                            <span className="checkicon">
                                                                <i className="bi bi-check"></i>
                                                            </span>
                                                        </CustomToggle>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                    <div className="saved-card-list">
                                        <CustomToggle eventKey="Stripe" activeKey={activeKey} setActiveKey={setActiveKey}>
                                            <div className="d-flex justify-content-between align-items-center w-100">
                                                <span>
                                                    <PaymentIcon type={"discover"} format="flatRounded" width={44} />
                                                    <PaymentIcon type={"visa"} format="flatRounded" className="ms-2" width={44} />
                                                    <PaymentIcon type={"mastercard"} format="flatRounded" className="ms-2" width={44} />
                                                    <PaymentIcon type={"maestro"} format="flatRounded" className="ms-2" width={44} />
                                                    <PaymentIcon type={"amex"} format="flatRounded" className="ms-2" width={44} />
                                                </span>
                                                <span className="checkicon">
                                                    <i className="bi bi-check"></i>
                                                </span>
                                            </div>
                                        </CustomToggle>
                                        <CustomToggle eventKey="Paypal" activeKey={activeKey} setActiveKey={setActiveKey}>
                                            <div className="d-flex justify-content-between align-items-center w-100">
                                                <span>
                                                    <img width={100} src={paypalImg} alt="Icon" />
                                                </span>
                                                <span className="checkicon">
                                                    <i className="bi bi-check"></i>
                                                </span>
                                            </div>
                                        </CustomToggle>

                                        {activeKey === "Stripe" && (
                                            <Elements stripe={stripePromise}>
                                                <StripeElement
                                                    subscriptionData={subscriptionData}
                                                    showPaymentModal={showPaymentModal}
                                                    setShowPaymentModal={setShowPaymentModal}
                                                    setShowStatusModal={setShowStatusModal}
                                                />
                                            </Elements>
                                        )}
                                        {activeKey === "Paypal" && (
                                            <PayPalScriptProvider options={{
                                                clientId: process.env.REACT_APP_PAYPAL_CLIENT_ID,
                                                components: "buttons",
                                                intent: "subscription",
                                                vault: true,
                                                // debug: true
                                            }}>
                                                <PaypalElement
                                                    subscriptionData={subscriptionData}
                                                    showPaymentModal={showPaymentModal}
                                                    setShowPaymentModal={setShowPaymentModal}
                                                    setShowStatusModal={setShowStatusModal}
                                                />
                                            </PayPalScriptProvider>
                                        )}
                                    </div>
                                </>
                            </Accordion>
                            {savedCardList?.data?.length > 0 && activeKey != "Stripe" && activeKey != "Paypal" && activeKey && (
                                <div className="form-btn-groups d-flex justify-content-end mt-4">
                                    <button
                                        type="button"
                                        onClick={handlePaymentCancel}
                                        className="btn btn-secondary-color btn-border-color"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        disabled={isProcessing}
                                        className="btn btn-primary-color ms-3"
                                        onClick={handleSubmitCardPay}
                                    >
                                        {isProcessing ? <LoadingSpinnerDotted /> : "Pay Now"}
                                    </button>
                                </div>
                            )}
                        </>
                    }
                </Modal.Body>
            </Modal>
            {showStatusModal?.isOpen && (
                <StatusModal
                    showStatusModal={showStatusModal}
                    setShowStatusModal={setShowStatusModal}
                    subscriptionFnc={subscriptionFnc}
                />
            )}
        </>
    );
}

export default PaymentModal;
